import { ArrowClockwise } from '@phosphor-icons/react'
import { Loader } from 'react-feather'
import { KeyedMutator } from 'swr'
import { useLocale } from 'src/lib/hooks/useLocal'

interface ResyncButtonProp {
  isLoading: boolean
  mutateSuggestion: KeyedMutator<any>
  status: string
}

export const ResyncButton: React.FC<ResyncButtonProp> = ({ isLoading, mutateSuggestion, status }) => {
  const { t } = useLocale()

  //handle resync - get all feature tickets data
  const handleResync = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault()
    event.stopPropagation()
    mutateSuggestion()
  }

  return (
    status === 'todo' && (
      <span
        onClick={handleResync}
        className='bg-black text-white mr-6 px-2 py-2 text-text-sm-bold rounded-lg cursor-pointer'
      >
        {isLoading ? (
          <Loader className='animate-spin' size={20} />
        ) : (
          <span className='flex gap-2 items-center'>
            <ArrowClockwise /> <span>{t('resync_button_text')}</span>
          </span>
        )}
      </span>
    )
  )
}
